export const STATUS_ENUM = {
  WAITING: 'WAITING',
  IN_PROGRESS: 'IN_PROGRESS',
  PATIENT_IN_SESSION: 'PATIENT_IN_SESSION',
  FINISHED: 'FINISHED',
  CANCELLED_BY_PATIENT: 'CANCELLED_BY_PATIENT',
  CANCELLED_BY_DOCTOR: 'CANCELLED_BY_DOCTOR',
  CANCELLED_BY_SYSTEM: 'CANCELLED_BY_SYSTEM',
  PATIENT_MISSED: 'PATIENT_MISSED'
}
